const state = {
  requestLog: [],
  error: '',
  errorMessage: undefined,
  errorCode: undefined,
  isReferralFlow: undefined
};
export default state;
